module.exports = __webpack_public_path__ + "static/image2-4f3d0966c5a782b8bef6fcbad35bd4ce.jpg";